/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './channels.stache';
import FeedService from 'scripts/services/base-feed-service';
import appContext from 'scripts/app-context';
import _ from 'lodash';

const channelsUrl = window.globalSettings.feeds.videos.liveScheduleUrl;

Component.extend({
    tag: 'live-channels',
    template,
    viewModel: {
        activeChannel: null,
        initLoad: true,
        define: {
            cards: {
                Type: can.List,
                Value: can.List,
            },
        },

        isActiveChannelLive: function(cards) {
            let isLive = _.find(cards, (channel) => {
                if (
                    channel &&
                    channel.video &&
                    channel.video.identifier == this.attr('activeChannel')
                ) {
                    return true;
                }
            });

            return isLive;
        },

        selectChannel: function(state, channelId, handleAlert) {
            if (state !== 'live') {
                return;
            }

            if (handleAlert) {
                let card = _.find(this.attr('liveCards'), (item) => {
                    return item.identifier == channelId;
                });

                if (card) {
                    channelId = card.video.identifier;
                } else {
                    return;
                }
            }

            this.attr('activeChannel', null);

            appContext.model.dispatch('live-channel-selected', [
                this.getVideoStreams(channelId),
            ]);
        },

        getVideoStreams(selectedStreamId) {
            const streams = [];

            _.forEach(this.attr('liveCards'), (card) => {
                streams.push({
                    id: card.video.identifier,
                    channel: card.channel,
                    title: card.title,
                });
            });

            _.sortBy(streams, ['channel']);

            if (selectedStreamId) {
                const selectedStreamIndex = _.findIndex(
                    streams,
                    (stream) => stream.id == selectedStreamId,
                );

                streams.unshift(...streams.splice(selectedStreamIndex, 1));
            }
            return streams;
        },
    },
    events: {
        inserted: function() {
            can.route(':channelId', {});

            appContext.model.bind(
                'live-video-player-play',
                (event, channelId) => {
                    this.viewModel.attr('activeChannel', channelId);
                    can.route.attr('channelId', channelId);
                },
            );

            appContext.model.bind('live-alert-watch', (event, channelId) => {
                this.viewModel.selectChannel('live', channelId, true);
            });

            can.route.ready();

            new FeedService(channelsUrl, false, true)
                .on('data', (type, data) => {
                    let cards = data.cards || [];

                    // TODO: Create live video feed service and make filtration there
                    cards = cards.filter((card) => {
                        if (card.channelIdentifier === 'audio') {
                            return false;
                        }

                        return true;
                    });

                    let refresh = this.compareCards(cards);
                    if (refresh) {
                        this.viewModel.attr('activeChannel', null);
                        this.updateCards(cards, true);
                    } else {
                        if (!this.viewModel.isActiveChannelLive(cards)) {
                            this.viewModel.attr('activeChannel', null);
                        }
                        this.updateCards(cards, false);
                    }
                })
                .on('error', (error) => {
                    console.error('Error fetching live channels', error);
                })
                .fetch();
        },
        compareCards: function(newCards) {
            let cards = this.viewModel.attr('cards');
            let update = false;

            if (cards && cards.length) {
                let newliveCardsIds = _.map(newCards, (value, index) => {
                    return value.video.identifier;
                });
                let currentCardsIds = _.map(cards, (value, index) => {
                    return value.video.identifier;
                });
                if (_.isEqual(newliveCardsIds, currentCardsIds)) {
                    update = false;
                } else {
                    update = true;
                }
            } else {
                update = true;
            }
            return update;
        },
        updateCards: function(cards, updateStreams) {
            let initChannelId = can.route.attr('channelId'),
                initLoad = this.viewModel.attr('initLoad'),
                liveCards = _.map(cards || [], (card) => {
                    if (card) {
                        card.channel = parseInt(
                            _.get(card, 'identifier', '').replace(
                                'channel',
                                '',
                            ),
                        );

                        if (isNaN(card.channel)) {
                            console.error(
                                `Wrong channel ${
                                    card.channel
                                } for audio ${_.get(card, 'video.identifier')}`,
                            );
                            return null;
                        }
                    }

                    return card;
                }).filter((card) => {
                    return card && card.streamState === 'live';
                });

            if (initChannelId) {
                const initChannelIdIndex = _.findIndex(
                    liveCards,
                    (card) =>
                        card.video &&
                        card.video.identifier &&
                        card.video.identifier == initChannelId,
                );

                if (initChannelIdIndex === -1) {
                    initChannelId = null;
                    can.route.removeAttr('channelId');
                }
            }

            this.viewModel.attr('cards', cards);
            this.viewModel.attr('liveCards', liveCards);

            const videoPlayerStreams = this.viewModel.getVideoStreams(
                initChannelId,
            );

            if (videoPlayerStreams.length && updateStreams) {
                appContext.model.dispatch('live-channel-streams-loaded', [
                    videoPlayerStreams,
                    true,
                    initLoad,
                ]);
            }

            if (initLoad) {
                this.viewModel.attr('initLoad', false);
            }
        },
    },
});
